import type { Moment } from "moment"
import baseMoment from "moment"
import { extendMoment } from "moment-range"

const moment = extendMoment(baseMoment)

export default moment
export type { Moment }
